'use client';
import Accordion, { AccordionItem } from '@repo/ui/src/components/Accordion';
import Markdown from '@repo/ui/src/components/Markdown';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import type { MeaterProduct } from '@src/domain/types/MeaterProduct';

type PDPAccordionProps = Pick<
  MeaterProduct,
  'featuresDescription' | 'specs' | 'shippingAndReturns'
>;

const PDPAccordion = ({ featuresDescription, specs, shippingAndReturns }: PDPAccordionProps) => {
  const { t } = useTranslation();

  const shippingContent =
    shippingAndReturns ??
    t('productDetailPageContent.shippingAndReturnsText', undefined, {
      default: null,
    });

  const items = [
    featuresDescription && {
      uuid: 'description',
      heading: t('productDetailPageContent.descriptionHeading', undefined, {
        default: 'Description',
      }),
      content: featuresDescription,
    },
    specs && {
      uuid: 'specs',
      heading: t('productDetailPageContent.specsHeading', undefined, { default: 'Specs' }),
      content: specs,
    },
    shippingContent && {
      uuid: 'shipping',
      heading: t('productDetailPageContent.shippingAndReturnsHeading', undefined, {
        default: 'Shipping & Returns',
      }),
      content: shippingContent,
    },
  ].filter(Boolean) as Array<{ uuid: string; heading: string; content: string }>;

  if (items.length === 0) return null;

  return (
    <Accordion
      allowZeroExpanded
      preExpanded={[items[0].uuid]}
      className="border-b border-neutral-200"
    >
      {items.map((item) => (
        <AccordionItem
          key={item.uuid}
          uuid={item.uuid}
          heading={item.heading}
          headerClassName="border-t border-neutral-200"
          headerFontClass="tra-text-web-heading-5 text-neutral-700"
          className="font-roboto text-base leading-6 !mt-0"
        >
          <Markdown bodySize="large">{item.content}</Markdown>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default PDPAccordion;
